import React from 'react';

const ResetDataModal = ({ setResetDataModal, resetDataModal, handleResetScore, matchData, loading }) => {
  return (
    <div className="fixed top-0 z-[60] left-0 right-0 bottom-0 bg-black bg-opacity-35 min-h-screen  justify-center items-center w-full flex">
      <div className="w-1/2 h-1/2 bg-white rounded p-10 flex flex-col justify-center items-center gap-16">
        {
          loading ? (
            <div className="flex justify-center items-center text-6xl font-bebas">
              Loading...
            </div>
          ) : (
           <>
         <p className="text-6xl font-bebas text-center">
          Are you sure you want to reset the score?
        </p>
        <div className="w-1/2 flex gap-10 items-center justify-center">
          <button
            onClick={() => setResetDataModal(!resetDataModal)}
            className="w-1/3 h-20 font-bebas text-4xl rounded bg-black text-white "
          >
            No
          </button>
          <button
            onClick={() => handleResetScore(matchData.event_id)}
            className="w-1/3 h-20 font-bebas text-4xl rounded bg-primary text-white "
          >
            Yes
          </button>
        </div>
        </>
        )}
      </div>
    </div>
  );
};

export default ResetDataModal;
